/**
 * Data access for the Locations page. Reads sites from the API, which loads
 * Site / StorageLocation / Bin rows from the database.
 */
import { locationsService } from '../../services/locationsService';
import type { Site } from './types';

export async function getSites(): Promise<Site[]> {
  return locationsService.listSites();
}
